import { Button } from "@patient-watch/ui/button";
import { X } from "lucide-react";
import { cn } from "../../lib/utils";
import { useProfileCopy } from "@/features/i18n/profileCopy";

interface Props {
    children: React.ReactNode;
    className?: string;
    show: boolean;
    setShow: (show: boolean) => void;
}
const Banner = ({ children, className, show, setShow }: Props) => {
    const copy = useProfileCopy();
    return (
        <div
            id="sticky-banner"
            tabIndex={-1}
            className={cn(
                "justify-between items-center bg-slate-50 dark:bg-sky-700 p-4 border-slate-200 dark:border-sky-700 border-b w-full",
                show ? "flex" : "hidden",
                className
            )}
        >
            {children}
            <div className="flex items-center">
                <Button
                    tabIndex={-1}
                    onClick={() => setShow(false)}
                    data-dismiss-target="#sticky-banner"
                    type="button"
                    size="icon"
                    variant="ghost"
                    className="p-1 rounded-md w-8 h-8"
                >
                    <X size={24} />
                    <span className="sr-only">{copy.closeBanner}</span>
                </Button>
            </div>
        </div>
    );
};

export default Banner;
